{
  "version": 1,
  "asset_id": "b937879b-cdae-432d-a212-0f6f0c19a9da",
  "project_id": "e0494bb4-679b-49cc-bb67-a16272adef1b",
  "url": "/__l5e/assets-v1/b937879b-cdae-432d-a212-0f6f0c19a9da/speaker-hero-v2.webp",
  "r2_key": "a/v1/e0494bb4-679b-49cc-bb67-a16272adef1b/b937879b-cdae-432d-a212-0f6f0c19a9da/speaker-hero-v2.webp",
  "original_filename": "speaker-hero-v2.webp",
  "size": 50676,
  "content_type": "image/webp",
  "created_at": "2026-06-13T02:14:28Z"
}
